import React, { useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import { ColDef, themeBalham } from 'ag-grid-community';
import { format } from 'date-fns';
import { ReglementClientDTO } from '../../../utils/types/objects/ReglementClientDTO';

const LastPaymentsGrid: React.FC<{ items: ReglementClientDTO[] }> = ({ items }) => {
    const [columnDefs] = useState<ColDef<ReglementClientDTO>[]>([
        { field: 'noRecu', headerName: 'No Reçu' },
        {
            field: 'datePaiement',
            headerName: 'Date',
            valueFormatter: (p) => (p.value ? format(new Date(p.value), 'dd/MM/yyyy') : ''),
        },
        { field: 'station', headerName: 'Station' },
        {
            field: 'montantPaye',
            headerName: 'Montant payé (USD)',
            type: 'numericColumn',
            valueFormatter: (p) => (p.value ? new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'USD' }).format(p.value) : ''),
        },
        { field: 'modePaiement', headerName: 'Mode paiement' },
    ]);

    return (
        <div style={{ width: '100%', height: 200 }}>
            <AgGridReact theme={themeBalham} rowData={items} columnDefs={columnDefs} defaultColDef={{ flex: 1, resizable: true, minWidth: 100 }} overlayNoRowsTemplate="<span style='padding: 10px;'>Aucune donnée ...</span>" />
        </div>
    );
};

export default LastPaymentsGrid;
